module.exports = __webpack_public_path__ + "media/img/corporate/second-line-95bdcef32d823338f74e2cb96355bcab.svg";